<div class="help-desk-form p-4">
  <div class="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:border-blue-800">
    <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Contact Support</h3>
    <p class="text-sm text-gray-600 dark:text-gray-300 mb-1">Need immediate assistance? Reach out to us directly.</p>
    <div class="flex flex-col sm:flex-row gap-4 mt-3">
      <div class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
        <span class="material-symbols-outlined text-sky-600 dark:text-sky-400">email</span>
        <a href="mailto:support@accidentmate.com" class="hover:underline" data-cy="page-support-link-email">support@accidentmate.com</a>
      </div>
      <div class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
        <span class="material-symbols-outlined text-sky-600 dark:text-sky-400">phone</span>
        <a href="tel:8889821882" class="hover:underline" data-cy="page-support-link-phone">(888) 982-1882</a>
      </div>
    </div>
  </div>

  <form [formGroup]="helpDeskForm" (ngSubmit)="onSubmit()">
    <div class="mb-4">
      <label for="subject" class="block text-sm font-medium text-gray-700 dark:text-gray-100"
        >Subject <span class="text-red-500">*</span></label
      >
      <input
        id="subject"
        type="text"
        formControlName="subject"
        class="w-full p-2 border rounded-md placeholder:text-gray-400 rounded-md px-3 py-2 text-base border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-sky-500 focus:border-sky-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        data-cy="page-helpDesk-input-subject"
      />
      @if (helpDeskForm.get('subject')?.invalid && helpDeskForm.get('subject')?.touched) {
      <div class="text-red-500 text-xs mt-1">Subject is required.</div>
      }
    </div>

    <div class="mb-4">
      <label for="description" class="block text-sm font-medium text-gray-700 dark:text-gray-100"
        >Description <span class="text-red-500">*</span></label
      >
      <textarea
        id="description"
        formControlName="description"
        rows="4"
        class="w-full p-2 border rounded-md placeholder:text-gray-400 rounded-md px-3 py-2 text-base border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-sky-500 focus:border-sky-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        data-cy="page-helpDesk-textarea-description"
      ></textarea>
      @if (helpDeskForm.get('description')?.invalid && helpDeskForm.get('description')?.touched) {
      <div class="text-red-500 text-xs mt-1">Description is required.</div>
      }
    </div>

    @if (confirmationMessage()) {
    <div class="text-green-600 text-sm text-center mb-4">{{ confirmationMessage() }}</div>
    } @if (errorMessage()) {
    <div class="text-red-500 text-sm text-center mb-4">{{ errorMessage() }}</div>
    }

    <div class="flex justify-end space-x-2">
      <button
        type="button"
        title="Close"
        (click)="onCancel()"
        class="px-4 py-2 border border-gray-300 cursor-pointer rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
        data-cy="page-helpDesk-button-cancel"
      >
        Cancel
      </button>
      <button
        type="submit"
        title="Submit support ticket"
        [disabled]="helpDeskForm.invalid || isLoading()"
        class="px-4 py-2 bg-sky-600 text-white rounded-md cursor-pointer shadow-sm text-sm font-medium hover:bg-sky-600/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
        data-cy="page-helpDesk-button-submitTicket"
      >
        @if (!isLoading()) {
        <span>Submit Ticket</span>
        } @if (isLoading()) {
        <app-spinner class="h-5 w-5 text-white"></app-spinner>
        }
      </button>
    </div>
  </form>

  <!-- Cancel Confirmation Modal -->
  @if (showCancelModal()) {
  <app-modal [isOpen]="true" (closeModal)="closeCancelModal()">
    <h3 class="text-lg font-semibold mb-4">Confirm</h3>
    <p class="mb-4">Are you sure you want to cancel? Any information you have entered will be lost.</p>
    <div class="flex justify-end space-x-2">
      <button (click)="closeCancelModal()" class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-cy="page-confirmCancelDialog-button-continue">
        No, Continue
      </button>
      <button (click)="confirmCancel()" class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" data-cy="page-confirmCancelDialog-button-confirm">
        Yes, Cancel
      </button>
    </div>
  </app-modal>
  }
</div>
